export const LAPTOP_WIDTH = 1441;